import api from "api/api";
import { HTTP_STATUS_CODE } from "constants/constants";

export const getAnnualBalanceSheetByTokenQuery = async ({
  slug,
  token,
  page,
}) =>
  await api.get(
    `/balancesheet/person/slug/${slug}/${token} ${page ? "page=" + page : ""}`
  );
export const saveAnnualEvaluationQuery = async ({ id, data }) =>
  await api.post(`/balancesheet/person/save/${id}`, data);

export const getAnnualEvaluationByIdQuery = async ({
  person_id,
  evaluation_id,
  isExport,
}) =>
  await api.get(`/balancesheet/person/${person_id}/${evaluation_id}`, {
    params: { export: isExport },
  });

export const sendAnnualEvaluationReminderQuery = async ({
  person_id,
  evaluation_id,
}) =>
  await api.post(`/balancesheet/person/reminder/${person_id}/${evaluation_id}`);

const buildAnnualEvaluationFieldFileFormData = ({
  evaluation_id,
  field_id,
  file,
  module_id,
}) => {
  const formData = new FormData();
  formData.append("evaluation_id", evaluation_id);
  formData.append("field_id", field_id);
  formData.append("file", file);
  formData.append("module_id", module_id);
  return formData;
};

export const uploadAnnualEvaluationFieldFileQuery = async ({
  evaluation_id,
  field_id,
  file,
  module_id,
  slug,
  token,
}) => {
  const payload = buildAnnualEvaluationFieldFileFormData({
    evaluation_id,
    field_id,
    file,
    module_id,
  });
  const requestOptions = {
    suppressUnauthorizedRedirect: true,
    withCredentials: true,
    omitAuthHeader: Boolean(slug && token),
  };
  const request = () =>
    api.putFile("/balancesheet/person/file", payload, requestOptions);

  try {
    return await request();
  } catch (error) {
    if (error?.response?.status === HTTP_STATUS_CODE.UNAUTHORIZED) {
      return await request();
    }
    throw error;
  }
};

export const exportAnnualBalanceSheetPdfQuery = async ({
  scope,
  person_id,
  evaluation_id,
}) =>
  await api.getBlob(
    `/balancesheet/person/export/pdf?scope=${scope}&person_id=${person_id}&evaluation_id=${evaluation_id}`
  );

export const downloadAnnualEvaluationFileQuery = async ({ file_id }) =>
  await api.getBlob(`/file/evaluation/${encodeURIComponent(file_id)}`);
